import { render, staticRenderFns } from "./AlarmTabs.vue?vue&type=template&id=174bea95&scoped=true"
import script from "./AlarmTabs.vue?vue&type=script&lang=js"
export * from "./AlarmTabs.vue?vue&type=script&lang=js"
import style0 from "./AlarmTabs.vue?vue&type=style&index=0&id=174bea95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174bea95",
  null
  
)

/* custom blocks */
import block0 from "./AlarmTabs.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports